module.exports = __webpack_public_path__ + "static/media/pin_restaurantes.24385e93.png";